// src/firebase.js
// ============================================================
// INSTRUCTIONS: Replace the config below with YOUR Firebase
// project credentials from https://console.firebase.google.com
// ============================================================
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCfoW_mjEk_3ifBR7CfMPLTgU3Fulcx7PU",
  authDomain: "shipfast-9e48a.firebaseapp.com",
  projectId: "shipfast-9e48a",
  storageBucket: "shipfast-9e48a.firebasestorage.app",
  messagingSenderId: "724348698073",
  appId: "1:724348698073:web:688c533763e24e937badc8",
  measurementId: "G-2KJTYQMVED",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
